import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { ActivatedRoute } from "@angular/router";

import {
  Discussion,
  User,
  UserService,
  PanelMember,
  CommentListConfig,
} from "../../../shared";

@Component({
  selector: "discussion-viewer",
  templateUrl: "./discussion-viewer.component.html",
  styleUrls: [
    "./discussion-viewer.component.scss",
    "../../../../assets/icon/icofont/css/icofont.scss",
    "../../../../../node_modules/sweetalert2/src/sweetalert2.scss",
  ],
  encapsulation: ViewEncapsulation.None,
})
export class DiscussionViewerComponent implements OnInit {
  public discussion: Discussion;
  public currentUser: User;
  public canModifyDiscussion: boolean;
  public currentPanelMember: PanelMember;
  public isPanelMember: boolean;
  public config: CommentListConfig = new CommentListConfig();

  constructor(private route: ActivatedRoute, private userService: UserService) {
    this.config = { sortBy: "latest", limit: 2 };
  }

  ngOnInit() {
    this.fetchDiscussion();
  }

  public fetchDiscussion() {
    this.route.data.subscribe((data: { discussion: Discussion }) => {
      this.discussion = data.discussion;
      this.fetchUser();
    });
  }

  public fetchUser() {
    this.userService.currentUser.subscribe((userData: User) => {
      this.currentUser = userData;

      this.canModifyDiscussion =
        this.currentUser.username === this.discussion.author.username;

      if (this.discussion.panel.length > 0) {
        this.currentPanelMember = this.discussion.panel.filter(
          (panelSeat) => panelSeat.member.username === this.currentUser.username
        )[0];
      }
    });
  }
}
